module.exports = __webpack_public_path__ + "static/media/10_Conexion_Conica.ad3a8036.png";